import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';
import Checkbox from 'components/common/checkbox-component';

const COE_ACCESS_DISCLAIMER_BLOCK = 'coe-access-disclaimer-modal';
const COE_ACCESS_DISCLAIMER_ID_BLOCK = 'coe-access-disclaimer-modal-id';

export const AcknoledgeCOEAccessDisclaimerModal = ({ onClose, onSubmit }) => {
  const [toggleAcknowledge, setToggleAcknowledge] = useState(false);
  return (
    <Modal
      id={`${COE_ACCESS_DISCLAIMER_ID_BLOCK}`}
      title={
        'project-creation.manage-users.coe-team-access.disclaimer-modal-title'
      }
      primaryModalButton={
        new ModalButton({
          text: 'common.submit',
          onClick: onSubmit,
          disabled: !toggleAcknowledge,
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: 'common.cancel',
          onClick: onClose,
        })
      }
      onClose={onClose}
    >
      <div className={`${COE_ACCESS_DISCLAIMER_BLOCK}__para-1`}>
        <FormattedMessage
          id={
            'project-creation.manage-users.coe-team-access.disclaimer-modal-message-first-paragraph'
          }
        />
      </div>
      <div className={`${COE_ACCESS_DISCLAIMER_BLOCK}__para-2`}>
        <FormattedMessage
          id={
            'project-creation.manage-users.coe-team-access.disclaimer-modal-message-sec-paragraph'
          }
        />
      </div>
      <div className={`${COE_ACCESS_DISCLAIMER_BLOCK}__checkbox`}>
        <Checkbox
          checked={toggleAcknowledge}
          onChange={() => setToggleAcknowledge(!toggleAcknowledge)}
          label={
            'project-creation-edit.manage-users.acknowledge-support-team-access'
          }
          id={`${COE_ACCESS_DISCLAIMER_ID_BLOCK}-disclaimer-checkbox`}
          width={'100%'}
          isValid={true}
        />
      </div>
    </Modal>
  );
};

AcknoledgeCOEAccessDisclaimerModal.propTypes = {
  /** function fired to close the modal */
  onClose: PropTypes.func.isRequired,
  /** function fired to submit acknowledgement */
  onSubmit: PropTypes.func.isRequired,
};
